import React from 'react';
import { useApiLoadingPool, usePreventInfiniteLoading, useRouter, useScrollToTop, } from '@/util/hook/custom';
import useCallback from '@/util/hook/useCallback';
import useDispatch from '@/util/hook/useDispatch';
import useMemo from '@/util/hook/useMemo';
import useSelector from '@/util/hook/useSelector';
import useState from '@/util/hook/useState';
import { selectLiffId } from '@/util/redux/auth';
import { getRequiredGenderOptionList } from '../../util/helper/option';
import { handleParamVerifyAndCachePut } from '../../util/helper/paramVerifyAndCachePut';
import { useGetCareClientVisitorProfile } from '../../util/hook/useGetCareClientVisitorProfile';
import { useGetRemoteConfig } from '../../util/hook/useGetRemoteConfig';
import { useScrollToInputField } from '../../util/hook/useScrollToInputField';
import { useTrackBrowserHistory } from '../../util/hook/useTrackBrowserHistory';
import { useValidateCareClientVisitorProfileAndRedirect } from '../../util/hook/useValidateCareClientVisitorProfileAndRedirect';
import { useValidateCareOrderBabyForm } from '../../util/hook/useValidateCareOrderBabyForm';
import { careOrderBabyFormUpdate, selectCareOrderBabyForm, } from '../../redux/module/careOrderBabyForm';
import View from './View';
import { APP } from '../../config/app';
import { POPUP_TYPE } from '../../config/popup';
import { CareOrderBabyFormForCachePutDConverter } from '../../util/dataConverter/CareOrderBabyFormForCachePutDConverter';
import { CareOrderBabyFormForParamVerifyDConverter } from '../../util/dataConverter/CareOrderBabyFormForParamVerifyDConverter';
import { CareOrderBabyFormUConverter } from '../../util/uiConverter/CareOrderBabyForm';
export default function Controller() {
    const { isLoading, setLoading, setApiProcessingPool, setApiDonePool } = useApiLoadingPool(true);
    const [popupType, setPopupType] = useState(POPUP_TYPE.CLOSE);
    const _id = useSelector(selectLiffId);
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    const { getIsFieldError, removeErrorType, setErrorTypes } = useValidateCareOrderBabyForm({
        requiredGender: careOrderBabyForm.requiredGender,
        lang: careOrderBabyForm.lang,
        servedItem: careOrderBabyForm.servedItem,
    });
    const { careOrderBabyFormInputFieldRefMap, scrollToInputField } = useScrollToInputField();
    const { navigate, navigateError } = useRouter();
    const dispatch = useDispatch();
    useTrackBrowserHistory();
    useGetRemoteConfig({ setApiProcessingPool, setApiDonePool });
    useGetCareClientVisitorProfile({ setApiProcessingPool, setApiDonePool });
    useValidateCareClientVisitorProfileAndRedirect({ redirectRoute: null });
    useScrollToTop();
    usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool });
    const requiredGenderOptionList = getRequiredGenderOptionList();
    const isRequiredGenderError = getIsFieldError('requiredGender');
    const isLangError = getIsFieldError('lang');
    const isServedItemError = getIsFieldError('servedItem');
    const careOrderBabyFormForCareRequirementPage = useMemo(() => {
        const data = CareOrderBabyFormUConverter.getDataForCareRequirementPage({ careOrderBabyForm });
        return data;
    }, [careOrderBabyForm]);
    // event handlers
    const handleRequiredGenderInputChange = useCallback((e) => {
        if (e.target.checked) {
            const requiredGender = e.target.value;
            dispatch(careOrderBabyFormUpdate({
                requiredGender,
            }));
        }
    }, []);
    const handleInputPopupClick = useCallback(({ errorType, popup }) => {
        removeErrorType(errorType);
        setPopupType(popup);
    }, []);
    const handleBackButtonClick = useCallback(() => {
        navigate(APP.ROUTES.PATIENT_INFO);
    }, []);
    const handleForwardButtonClick = async () => {
        const { data: paramVerifyParams } = new CareOrderBabyFormForParamVerifyDConverter({
            requiredGender: careOrderBabyForm.requiredGender,
            lang: careOrderBabyForm.lang,
            servedItem: careOrderBabyForm.servedItem,
        });
        const { data: careOrderBabyFormForCachePut } = new CareOrderBabyFormForCachePutDConverter({
            careOrderBabyForm,
        });
        const { isSuccess } = await handleParamVerifyAndCachePut({
            _id,
            params: { _id, ...paramVerifyParams },
            careOrderBabyFormForCachePut,
            careOrderBabyFormInputFieldRefMap,
            pageRoute: APP.ROUTES.CARE_REQUIREMENT,
            setLoading,
            setErrorTypes,
            scrollToInputField,
            navigateError,
        });
        if (isSuccess) {
            navigate(APP.ROUTES.NOTES_AND_AGREEMENT);
        }
    };
    return (<View 
    // data
    isLoading={isLoading} requiredGender={careOrderBabyForm.requiredGender} isRequiredGenderError={isRequiredGenderError} isLangError={isLangError} isServedItemError={isServedItemError} requiredGenderOptionList={requiredGenderOptionList} careOrderBabyFormInputFieldRefMap={careOrderBabyFormInputFieldRefMap} careOrderBabyFormForCareRequirementPage={careOrderBabyFormForCareRequirementPage} popupType={popupType} 
    // func
    setPopupType={setPopupType} handleRequiredGenderInputChange={handleRequiredGenderInputChange} handleInputPopupClick={handleInputPopupClick} handleBackButtonClick={handleBackButtonClick} handleForwardButtonClick={handleForwardButtonClick}/>);
}
